export const SUA_TIEN_LAI = 'SUA_TIEN_LAI';
export const SUA_TIEN_LAI_SUCCESS = 'SUA_TIEN_LAI_SUCCESS';
export const SUA_TIEN_LAI_FAILURE = 'SUA_TIEN_LAI_FAILURE';
export const SUA_TIEN_GOC = 'SUA_TIEN_GOC';
export const SUA_TIEN_GOC_SUCCESS = 'SUA_TIEN_GOC_SUCCESS';
export const SUA_TIEN_GOC_FAILURE = 'SUA_TIEN_GOC_FAILURE';
export const SUA_TIEN_GOP = 'SUA_TIEN_GOP';
export const SUA_TIEN_GOP_SUCCESS = 'SUA_TIEN_GOP_SUCCESS';
export const SUA_TIEN_GOP_FAILURE = 'SUA_TIEN_GOP_FAILURE';
export const GET_SOTAISANTHANHLY_CAMDO = 'GET_SOTAISANTHANHLY_CAMDO';
export const GET_SOTAISANTHANHLY_CAMDO_SUCCESS =
  'GET_SOTAISANTHANHLY_CAMDO_SUCCESS';
export const GET_SOTAISANTHANHLY_CAMDO_FAILURE =
  'GET_SOTAISANTHANHLY_CAMDO_FAILURE';

export const NHAP_PHI_PHAT = 'NHAP_PHI_PHAT';
export const NHAP_PHI_PHAT_SUCCESS = 'NHAP_PHI_PHAT_SUCCESS';
export const NHAP_PHI_PHAT_FAILURE = 'NHAP_PHI_PHAT_FAILURE';
